import api from '@/apis'

export const fetchList = params => api.get(`/bonusCoupon`, { params })
export const deleteBonusCoupon = (id) => api.delete(`/bonusCoupon/${id}`)
export const addBonusCoupon = (data) =>  api.post(`/bonusCoupon`, data)
export const updateBonusCoupon = (id,data) =>  api.put(`/bonusCoupon/${id}`, data)
